
import { defineComponent } from 'vue';
import { AppInput, AppButton } from '@/components';
import { useLogin } from '@/modules/login/model/login';
import { ROUTE_NAME_PASSWORD } from '@/modules/forgot-password/router';
import { ROUTE_NAME_LOGIN } from '@/modules/login/router';

export default defineComponent({
    name: ROUTE_NAME_LOGIN.INDEX,
    components: { AppInput, AppButton },

    setup() {
        const { model, v$, login, loading } = useLogin();

        return { v$, model, login, loading, ROUTE_NAME_PASSWORD };
    }
});
